
<template>
  <h3 id="breadcrumbs" class="heading-page">
    <div v-if="loading">
      <loading-animation-vue :spinnerSize="40"></loading-animation-vue>
    </div>
    <div v-else>
      <span  v-for="(breadcrumb, index) in allBreadcrumbs" :key="index" :title="breadcrumb.name">
        <!-- Any breadcrumbs that are truncated will appear here when expanded no need to check for href as all should be links-->
        <template v-if="expandedBreadcrumbs.includes(breadcrumb.name) || expanded" >
          <!-- check if breadcrumb is a link-->
          <a v-if="breadcrumb.href !== null" class="breadcrumb" :href="breadcrumb.href" > 
            {{breadcrumb.name}}
          </a >
          <!-- else show as span-->
          <span class="breadcrumb" v-else >
            {{breadcrumb.name}}
          </span>
          <span v-if="index != allBreadcrumbs.length - 1" class='chevron'>
            <span><font-awesome-icon :icon="['fas', 'chevron-right']" /></span>
          </span>
        </template>
        <template v-else >
          <span v-if="index == 1">
            <a href="#" class="toggle_breadcrumb" @click="toggleCollapse">
              ...
            </a>
            <span class='chevron'>
              <font-awesome-icon :icon="['fas', 'chevron-right']" />
            </span>
          </span>
        </template>
      </span>    
    </div>
  </h3>
</template>


<script>
    export default {
        props: ['breadcrumbs'],
        data () {
            return { 
              current_width: 0,
              allBreadcrumbs: [], 
              expandedBreadcrumbs: [],
              character_length: 11,
              skip: false,
              max_character_length: 312,
              // if max_character_length is changed please change the css in .breadcrumb to match currently max-width: 312px;
              breadcrumb_length: null,
              expanded: false,
              loading: true 
            }
        },
        mounted () {
            window.addEventListener('resize', this.resetBreadcrumbs);  
            this.initializeBreadcrumbs();
            this.resetBreadcrumbs();
        },
        methods: {
          initializeBreadcrumbs() {
            try {
              this.allBreadcrumbs = JSON.parse(this.breadcrumbs);
            }
            catch {
              console.log('BREADCRUMBS NOT PROPERLY FORMATTED')
            }

          },
          resetBreadcrumbs() {
            // Add first and last into array to allow width to be calculated properly
            this.expandedBreadcrumbs = [this.allBreadcrumbs[0].name, this.allBreadcrumbs[this.allBreadcrumbs.length -1].name];
            this.checkWidth();
            this.skip = false
            // Since we show expanded breadcrumbs starting from the last one and working backwards check if each breadcrumb
            // starting from the last one will fit and remove accordingly
            this.allBreadcrumbs.reverse().forEach((breadcrumb) => {
              let that = this;
              if(!that.skip && !that.expandedBreadcrumbs.includes(breadcrumb.name)) {
                this.breadcrumbWillFit(breadcrumb.name)
              }
            })
            this.loading = false
            // When we render we want to show them in the right order so reverse back
            this.allBreadcrumbs.reverse()
          },
          breadcrumbWillFit(breadcrumb) {
            // Simulate it being in the list of expanded breadcrumbs
            this.expandedBreadcrumbs.push(breadcrumb)
            // account for the length of chevrons and ...
      
            const chevronCount = this.expandedBreadcrumbs.length <  this.allBreadcrumbs.length ? this.expandedBreadcrumbs.length + 1 : this.allBreadcrumbs.length - 1
            let breadcrumbLength = this.calcWidthOfArray(this.expandedBreadcrumbs) + chevronCount * 20
            // If it doesn't fit then remove it

            if(breadcrumbLength > this.current_width ) {
              this.skip = true
              this.expandedBreadcrumbs.pop();
            }
          },
          checkWidth() {
            // get the current width of the breadcrumb container
            let current_width = document.getElementById('breadcrumbs')
            if (current_width) {
              this.current_width = current_width.getBoundingClientRect().width; 
            }
          },
          toggleCollapse(e) {
            this.expanded = true
            e.preventDefault();
          },
          calcWidthOfArray(array) {
            // calculates the length of characters of the name of each item in the array
            let calcWidth = 0; 

              // Add 11 pixels for each character in array
            array.map((bc, i) => {
              let length = bc.length * this.character_length
              // if calculated width is greater then 300 use max width of 300
              if (length > this.max_character_length) {
                calcWidth = calcWidth + this.max_character_length
              } else {
                // else use the calculated length
                calcWidth = calcWidth + length
              }
            })
            return calcWidth
          },
        }
    }
</script>
